/**
 * Utility functions for navigation between POS and SmartPOS apps with auth token passing
 */

/**
 * Check URL for auth tokens and store them in localStorage
 * Should be called on app initialization before any other auth logic
 */
export const checkAndStoreAuthFromURL = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  const refreshToken = urlParams.get('refreshToken');
  const expiresAt = urlParams.get('expiresAt');

  if (token && refreshToken && expiresAt) {
    // Store auth tokens in localStorage (using accessToken key)
    localStorage.setItem('accessToken', token);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('expiresAt', expiresAt);

    // Clean the URL to remove auth params
    const newUrl = window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);

    return true; // Indicates tokens were found and stored
  }

  return false; // No tokens in URL
};

/**
 * Navigate to SmartPOS with current auth tokens (opens in new tab)
 */
export const navigateToSmartPOS = () => {
  const token = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');
  const expiresAt = localStorage.getItem('expiresAt');

  if (!token || !refreshToken || !expiresAt) {
    console.error('Cannot navigate to SmartPOS: Missing auth tokens');
    return;
  }

  const smartPosUrl = process.env.REACT_APP_SMARTPOS_URL || 'http://localhost:3000';
  const url = `${smartPosUrl}?token=${encodeURIComponent(token)}&refreshToken=${encodeURIComponent(refreshToken)}&expiresAt=${encodeURIComponent(expiresAt)}`;

  window.open(url, '_blank');
};

/**
 * Navigate to POS with current auth tokens (opens in new tab)
 */
export const navigateToPOS = () => {
  const token = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');
  const expiresAt = localStorage.getItem('expiresAt');

  if (!token || !refreshToken || !expiresAt) {
    console.error('Cannot navigate to POS: Missing auth tokens');
    return;
  }

  const posUrl = process.env.REACT_APP_POS_URL || 'http://localhost:3001';
  const url = `${posUrl}?token=${encodeURIComponent(token)}&refreshToken=${encodeURIComponent(refreshToken)}&expiresAt=${encodeURIComponent(expiresAt)}`;

  window.open(url, '_blank');
};


/**
 * Navigate to POS with current auth tokens (opens in new tab)
 */
export const navigateToPOSSellers = () => {
  const token = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');
  const expiresAt = localStorage.getItem('expiresAt');

  if (!token || !refreshToken || !expiresAt) {
    console.error('Cannot navigate to POS Sellers: Missing auth tokens');
    return;
  }

  const posUrl = process.env.REACT_APP_POS_URL || 'http://localhost:3001';
  const url = `${posUrl}?token=${encodeURIComponent(token)}&refreshToken=${encodeURIComponent(refreshToken)}&expiresAt=${encodeURIComponent(expiresAt)}`;

  window.location.href = url; 

};

